import { MaterialTransferido } from "@/shared/interfaces"
import { Box, Button, IconButton, TextField, Tooltip } from "@mui/material"
import { MRT_ColumnDef } from "material-react-table"
import { useCallback, useMemo } from "react"
import DeleteIcon from '@mui/icons-material/Delete';
import { MaterialesKey, useMaterialesUtilizadosStore } from "@/store/erp";
import { IKitInventario } from "@/shared/interfaces/erp/inventario/kit-inventario.interface";
import { formatDate } from "@/shared";
import { Visibility } from "@mui/icons-material";
import { InfoVerKitItemStore } from "@/shared/components/ui/InfoModalStore/InfoVerKitItem.store";

export const useTableColumnsKit = () => {

  const updateSelectedItemQuantity = useMaterialesUtilizadosStore(s => s.updateSelectedItemQuantity);

  ///* Aumentar cantidad
  const onChangeQuantity = useCallback(
    (value: string | boolean, item: MaterialTransferido) => {
      updateSelectedItemQuantity(
        { ...item, cantidad: +value },
        MaterialesKey.selectItemKit
      );
    },
    [updateSelectedItemQuantity]
  );

  const removeSelectedItem = useMaterialesUtilizadosStore(s => s.removeSelectedItem);

  const { setOpen, setProductos } = InfoVerKitItemStore()


  const columnBase = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'producto_data.codigo',
      header: 'Codigo',
      size: 100,
    },
    {
      accessorKey: 'producto_data.categoria_producto',
      header: 'Categoria',
      size: 150,
    },
    {
      accessorKey: 'producto_data.subcategoria_producto',
      header: 'SubCategoria',
      size: 150,
    },
    {
      accessorKey: 'producto_data.descripcion',
      header: 'Descripción',
      size: 150,
    },
    {
      accessorKey: 'producto_data.stock_actual',
      header: 'Stock Actual',
      size: 100,
    },
    {
      accessorKey: 'cantidad',
      header: 'Cantidad',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <TextField
            onKeyDown={(event) => {
              if (['e', 'E', '-', '.', ','].includes(event.key))
                event.preventDefault();

            }}
            variant="outlined"
            defaultValue={1}
            value={row.original.cantidad?.toString()}
            onChange={e => {
              let currentValue = e.target.value;
              onChangeQuantity(currentValue, {
                ...row.original,
                id: row.original.id,
              });
            }}
            type="number"
            inputProps={{ min: 0, step: 1 }}
          />
        );
      }
    },
    {
      accessorKey: 'accion',
      header: 'Acciones',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <Box sx={{ display: 'flex', gap: '1rem' }}>
            <Tooltip title="Eliminar">
              <IconButton
                onClick={() => {
                  removeSelectedItem(row.original.id!, MaterialesKey.selectItemKit);
                }}
              >
                <DeleteIcon color="error" />
              </IconButton>
            </Tooltip>
          </Box>
        );
      }
    },
  ], [])

  const columnViewBase = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'producto_data.codigo',
      header: 'Codigo',
      size: 100,
    },
    {
      accessorKey: 'producto_data.categoria_producto',
      header: 'Categoria',
      size: 150,
    },
    {
      accessorKey: 'producto_data.subcategoria_producto',
      header: 'SubCategoria',
      size: 150,
    },
    {
      accessorKey: 'producto_data.descripcion',
      header: 'Descripción',
      size: 150,
    },
    /* {
      accessorKey: 'producto_data.stock_actual',
      header: 'Stock Actual',
      size: 100,
    }, */
    {
      accessorKey: 'cantidad',
      header: 'Cantidad',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
    },

  ], [])

  const columnKitInventario = useMemo<MRT_ColumnDef<IKitInventario>[]>(() => [
    {
      accessorKey: 'codigo',
      header: 'Codigo Kit',
    },
    {
      accessorKey: 'nombre',
      header: 'Nombre Kit',
    },
    {
      accessorKey: 'productos_data',
      header: 'Productos',
      Cell: ({ row }) => {
        return row.original.productos != null
          ? <Button
            color="primary"
            endIcon={<Visibility />}
            onClick={() => {
              setOpen(true)
              setProductos(row.original.productos)
            }}
          >
            Ver items
          </Button>
          : 'N/A'
      }
    },
    {
      accessorKey: 'bodega_data.nombre',
      header: 'Bodega',
    },
    {
      accessorKey: 'ubicacion_data.nombre',
      header: 'Ubicación',
    },
    {
      accessorKey: 'fecha_creacion',
      header: 'Fecha Creación',
      Cell: ({ row }) => {
        return formatDate(row.original.fecha_creacion)
      },
    }
  ], [])



  return {
    columnBase,
    columnKitInventario,
    columnViewBase,
  }
}